import React from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import * as aor from "react-admin";
import { Button, Fade, Divider, Snackbar } from "@material-ui/core";
import myRestClient from "../common/restClient";
import tccStyles from "../common/styles";
import RichTextInput from "ra-input-rich-text";
import history from "../common/history";
import { Field } from "redux-form";
import AutoCompleteInputOld from "./AutoCompleteInputOld";

import TranslatedText from "./TranslatedText";
const typeOptions = {
    resource: "installation_types",
    display: "name",
    label: "Con installazioni:",
    isMulti: true,
    notRequired: true
};

class MessageBoard extends React.Component {
    state = {
        message: "",
        addressee: [],
        licenses: [],
        error_msg: "",
        types: []
    };

    handleClick = () => {
        this.setState({
            showSnackBar: false,
            error: false,
            error_msg: ""
        });
        const message = this.state.message;

        const resource_id = 0;
        const action = "sendAll";
        const addressee = this.state.addressee;
        const licenses = this.state.licenses;
        // body is handmade including message and the checkbox selected
        // resource_id, action are mandatory and hardcoded
        const body = {
            data: { message, resource_id, action, addressee, licenses }
        };
        myRestClient("CREATE", "email", body).then(
            () => {
                this.setState({
                    showSnackBar: true,
                    error: false,
                    message: "",
                    addressee: [],
                    licenses: [],
                    error_msg: ""
                });
                history.push(`/tickets`);
            },
            e => {
                this.setState({
                    showSnackBar: true,
                    error: true,
                    error_msg: e.message
                });
            }
        );
    };

    handleMessageChange = e => {
        var msg_value_html = Object.keys(e).map(function(key) {
            return e[key];
        });
        msg_value_html.pop();
        msg_value_html = msg_value_html.join("");
        this.setState({ message: msg_value_html });
        return;
    };

    handleAddressee = e => {
        // manage checkboxes "CLIENTS" / "USERS"
        var addressee_selected = Object.keys(e).map(function(key) {
            return e[key];
        });
        addressee_selected.pop();
        this.setState({ addressee: addressee_selected });
        return;
    };

    handleLicenses = e => {
        var licenses_selected = Object.keys(e).map(function(key) {
            return e[key];
        });
        licenses_selected.pop();
        this.setState({ licenses: licenses_selected });
        return;
    };

    handleClose = () => {
        this.setState({ showSnackBar: false });
    };

    renderSnackMessage() {
        return this.state.error === true ? (
            this.state.error_msg === "mandatory_addressee_licenses" ? (
                <span style={{ color: tccStyles.snackbar.errorColor }}>
                    <TranslatedText resource_name="mandatory_addressee_licenses" />
                </span>
            ) : (
                <span style={{ color: tccStyles.snackbar.errorColor }}>
                    <TranslatedText resource_name="notifactionSentError" />
                </span>
            )
        ) : (
            <span>
                <TranslatedText resource_name="notificationSent" />
            </span>
        );
    }

    renderSnackBar() {
        return (
            <Snackbar
                open={this.state.showSnackBar}
                autoHideDuration={5000}
                onClose={this.handleClose}
                TransitionComponent={Fade}
                ContentProps={{
                    "aria-describedby": "message-id"
                }}
                message={this.renderSnackMessage()}
            />
        );
    }

    render() {
        var toolbarOptions = [
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["bold", "italic", "underline", "strike"], // toggled button
            ["clean"]
        ];

        return (
            <div>
                <aor.Title title="resources.notifications.views.list.title" />
                <aor.SimpleForm toolbar={null}>
                    <div style={{ width: "100%" }}>
                        <Card>
                            <aor.ViewTitle
                                title={
                                    <TranslatedText resource_name="resources.notifications.nameSingular" />
                                }
                            />
                            <CardContent>
                                <aor.CheckboxGroupInput
                                    label="Destinatari:"
                                    source="addressee"
                                    choices={[
                                        {
                                            id: "CLIENTS",
                                            name: "CLIENTI"
                                        },
                                        {
                                            id: "USERS",
                                            name: "UTENTI"
                                        }
                                    ]}
                                    onChange={this.handleAddressee}
                                />
                                <Field
                                    name="licenses"
                                    component={AutoCompleteInputOld}
                                    {...{
                                        options: typeOptions
                                    }}
                                    onChange={this.handleLicenses}
                                />
                                <RichTextInput
                                    source="message"
                                    toolbar={toolbarOptions}
                                    onChange={this.handleMessageChange}
                                />
                                <br />
                                <Divider />
                                <br />
                                <Button
                                    color="primary"
                                    variant="contained"
                                    onClick={this.handleClick}
                                >
                                    <TranslatedText resource_name="send" />
                                </Button>
                            </CardContent>
                        </Card>
                        {this.renderSnackBar()}
                    </div>
                </aor.SimpleForm>
            </div>
        );
    }
}

export default MessageBoard;



// WEBPACK FOOTER //
// ./src/components/MessagesBoard.js